export const environment = {
  production: false,
  apiUrl: 'https://api.dev.cosmos.so/graphql',
};
